// Generated by ts-to-zod
import { z } from 'zod';

export const engineCreatePayloadSchema = z.object({
  name: z.string(),
  description: z.string(),
  type: z.literal('extractor'),
});
